// extracted by mini-css-extract-plugin
module.exports = {"button":"_WaUd5O0b","badge":"_9Y4Jtqzg","fullDealLabel":"_1JGKIVhY","actions":"_eXRd6niF","detailsButton":"_aK-2Z0PF","pskField":"_Z2tN-w1L"};